import logo from "./logo.svg";
import React, { useEffect } from 'react';
import "./App.css";
import "./AppStyle.css";
import ThemeProvider from "./theme";
import Router from "./routes";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { Suspense } from "react";
import Translation from "./common/translation/translation";
import { EnglishTranslations } from "./common/en";
import { PortugeseTranslations } from "./common/pr";
import Loader from "./utils/Loader";
import { LoaderProvider  } from "./utils/LoaderContext";
import {
  SnackbarProvider,
  closeSnackbar,
  MaterialDesignContent,
} from "notistack";
import { styled, css } from "@mui/material/styles";
import InfoIcon from "@mui/icons-material/Info";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const StyledMaterialDesignContent = styled(MaterialDesignContent)(() => ({
  "&.notistack-MuiContent-success": {
    backgroundColor: "#DDFFDF",
    color: "#212B36",
    fontWeight: 600,
    borderRadius: 18,
  },
  "&.notistack-MuiContent-error": {
    backgroundColor: "#FFE2E2",
    color: "#212B36",
    fontWeight: 600,
    borderRadius: 18,
  },
}));

const StyledSnackbarProvider = styled(SnackbarProvider)(({ theme }) => ({
  top: "120px !important",
  color: "violet",
  "&.notistack-SnackbarContainer": {
    backgroundColor: "red !important",
    top: "120px !important",
    marginTop: "120px !important",
  },
}));

const fetchData = async (setLoading) => {
  setLoading(true);
  //await fetch("https://app.tomaladaca.gov.pt/API/API/Donation/GetDonations");
  await fetch("https://app-qua.tomaladaca.gov.pt/API/API/Donation/GetDonations");
  //await fetch("https://localhost:44361/api/Donation/GetDonations");
 //await fetch("http://57.153.83.127:8080/API/API/Donation/GetDonations");
  setLoading(false);
};

const translationPr = PortugeseTranslations;
const translationEn = EnglishTranslations;
i18n.use(initReactI18next).init({
  resources: {
    en: { translation: translationEn },
    pr: { translation: translationPr },
  },
  lng: "en",
  fallbacking: "en",
  interpolation: { escapeValue: false },
});

const CloseSnackbar = ({ snackbarId }) => (
  <IconButton onClick={() => closeSnackbar(snackbarId)}>
    <CloseIcon />
  </IconButton>
);

function App() {
  return (
    <LoaderProvider>
<ThemeProvider>
      <SnackbarProvider
        maxSnack={3}
        autoHideDuration={3000}
        iconVariant={{
          success: (
            <InfoIcon
              sx={{
                backgroundColor: `#37B34A`,
                color: "white",
                width: 32,
                height: 32,
                padding: 0.5,
                mr: 1,
                borderRadius: "10px",
              }}
            />
          ),
          error: (
            <InfoIcon
              sx={{
                backgroundColor: `#DC2600`,
                color: "white",
                width: 32,
                height: 32,
                padding: 0.5,
                mr: 1,
                borderRadius: "10px",
              }}
            />
          ),
          warning: "⚠️",
          info: "ℹ️",
        }}
        Components={{
          success: StyledMaterialDesignContent,
          error: StyledMaterialDesignContent,
        }}
        action={(snackbarId) => <CloseSnackbar snackbarId={snackbarId} />}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        sx={{
          top: "120px !important",
        }}
      >
        <Suspense fallback="..loading translations">
          <Router />
        </Suspense>
      </SnackbarProvider>
    </ThemeProvider>
    <Loader />
    </LoaderProvider>
    
  );
}

export default App;
